import { memo, useState } from 'react'
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout'
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle'
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew'
import { trpc } from 'root/src/client/v2/trpc/trpc'
import { useModal } from 'root/src/client/v2/common/contexts/modal.context'
import toast from 'react-hot-toast'
import { getErrorMessage } from 'root/src/client/v2/common/hooks/useDareDropApi'
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles'

const RejectDareCardModal = memo(({ projectUrl, onSuccess }) => {
	const [message, setMessage] = useState('')
	const [isSubmitting, setIsSubmitting] = useState(false)
	const rejectMutation = trpc.project.reject.useMutation()
	const modal = useModal()

	const onSubmit = async (e) => {
		e.preventDefault()
		setIsSubmitting(true)
		try {
			await rejectMutation.mutateAsync({
				projectUrl,
				message,
			})
			toast.success('Dare rejected successfully!')
			await onSuccess?.()
			modal.hide()
		} catch (err) {
			const errorMessage = getErrorMessage(err)
			toast.error(errorMessage)
		} finally {
			setIsSubmitting(false)
		}
	}

	return (
		<ModalLayout className="sm:w-[500px]">
			<ModalTitle>
				Reject Dare
			</ModalTitle>
			<form onSubmit={onSubmit} className="flex flex-col gap-4 w-full py-4">
				<label className="text-sm text-gray-300">
					Reason:
				</label>
				<textarea
					className="w-full rounded-lg border-2 border-dark-1 bg-dark-2 text-white p-3 resize-none focus:outline-none focus:border-primary"
					placeholder="Email to pledgers, for example: It's too hard, you're more talented than me."
					value={message}
					onChange={e => setMessage(e.target.value)}
					maxLength={300}
					rows={4}
				/>
				<span className="text-xs text-gray-400 text-right">
					{message.length}/300
				</span>
				<ButtonNew
					type="submit"
					disabled={isSubmitting}
				>
					{isSubmitting
						? <LoadingCircles width={25} height={25} />
						: <>Confirm</>}
				</ButtonNew>
			</form>
		</ModalLayout>
	)
})

export default RejectDareCardModal
